<template>
    <div>
        <cl-form  :model="datas" :fields="fields" :urlSubmit="urlSubmit" :submitType="submitType" class="pz_manger"
                  :pageload="pageload" :btnDoReset="addOrEdit"  :oprah="oprah">
            <cl-form-row>
                <el-input ref="apiName" slot="apiName" v-model="datas.apiName" placeholder="请输入名称"></el-input>
                <el-input ref="apiCode" slot="apiCode" v-model="datas.apiCode" placeholder="请输入编码"></el-input>
            </cl-form-row>

            <!--条件数据库-->
            <cl-form-row>
<!--                <el-select clearable="true" ref="criteriaSearchId" slot="criteriaSearchId" v-model="datas.criteriaSearchId" placeholder="请选择条件数据源">-->
<!--                    <el-option-->
<!--                            v-for="item in searchList"-->
<!--                            :key="item.index"-->
<!--                            :label="item.sourceName"-->
<!--                            :value="item.databaseId"-->
<!--                    ></el-option>-->
<!--                </el-select>-->
                <el-radio-group ref="isFlag" slot="isFlag" size="mini" v-model="datas.isFlag">
                    <el-radio border label="0">是</el-radio>
                    <el-radio border label="1">否</el-radio>
                </el-radio-group>
            </cl-form-row>
<!--            <cl-form-row>-->
<!--                <el-input ref="criteriaSql" slot="criteriaSql" type="textarea"  v-model="datas.criteriaSql" :autosize="{minRows: 5,maxRows: 8}" placeholder="请输入查询语句"></el-input>-->
<!--            </cl-form-row>-->
            <!--条件数据库-->

            <cl-form-row>
                <el-select ref="searchId" slot="searchId" v-model="datas.searchId" placeholder="请选择数据源">
                    <el-option
                            v-for="item in searchList"
                            :key="item.index"
                            :label="item.sourceName"
                            :value="item.databaseId"
                    ></el-option>
                </el-select>
                <el-select  ref="apiType" slot="apiType"v-model="datas.apiType" placeholder="请选择数据数据类型">
                    <el-option
                            v-for="item in searchList2"
                            :key="item.index"
                            :label="item.z"
                            :value="item.m"
                    ></el-option>
                </el-select>

            </cl-form-row>

            <cl-form-row>
                <el-input ref="shSql" slot="shSql" type="textarea"  v-model="datas.shSql" :autosize="{minRows: 5,maxRows: 8}" placeholder="请输入查询语句"></el-input>
            </cl-form-row>
            <cl-form-row>
                <el-input ref="shParam" slot="shParam" type="textarea" v-model="datas.shParam" :autosize="{minRows: 5,maxRows: 8}" placeholder="请输入参数"></el-input>
            </cl-form-row>
            <cl-form-row>
                <el-input ref="remark" slot="remark" type="textarea" v-model="datas.remark" :autosize="{minRows: 5,maxRows: 8}" placeholder="请输入备注"></el-input>
            </cl-form-row>
            <el-button slot="customButtons" class="formBtnSubmit" type="primary " @click="handleClick" slot-scope={th}>
                <!-- {{th.btnTextCancal}} -->
                预览
            </el-button>
        </cl-form>
        <el-dialog title="数据预览" id="bigdat" class="dialog edit-dialog-style" :visible.sync="dialogTableVisible">
            <dataCreatFormNew :datas="datas" v-if="dialogTableVisible"></dataCreatFormNew>
        </el-dialog>
    </div>
</template>

<script>
    import dataCreatFormNew from '../dataCreat/dataCreatFormNew';
    export default {
        components: {
            dataCreatFormNew
        },
        data(){

            let id = this.openType;
            var that = this
            const ruleApiCode = function(coder, value, callback) {
                if (value !== '') {
                    if (that.openType === -1) {
                        that.request.get('/bigdata-visual/modelData/shApi/apiCode', {
                            apiCode: value,
                            shApiId: that.openType
                        }).then((res) => {
                            if (res.data === '0') {
                                return callback();
                            } else {
                                callback(new Error('接口编码已存在！'));
                            }
                        })
                    } else {
                        that.request.get('/bigdata-visual/modelData/shApi/apiCode', {
                            apiCode: value,
                            shApiId: that.openType
                        }).then((res) => {
                            if (res.data === '0') {
                                return callback();
                            } else {
                                callback(new Error('接口编码已存在！'));
                            }
                        })
                    }
                }
            }

            return {
                dialogTableVisible: false,
                oprah: {},
                openType: '',
                pageload: true,
                elOption: [],
                searchList:[],
                searchList2:[],
                searchId:'',
                apiType:'',
                fields: {
                    row1: [{
                        name: 'apiName',
                        label: '接口名称',
                        span: 12,
                        rules: [{
                            required: true,
                            message: '请输入接口名称',
                            trigger: 'blur'
                        },{
                            max:32,
                            message:'最多输入32个字',
                            trigger: 'blur'
                        },{
                            pattern: this.regex.chennum_,
                            message: '只能输入中文、英文、数字、下划线',
                            trigger: 'blur'
                        }]
                    },{
                        name: 'apiCode',
                        label: '接口编码',
                        span: 12,
                        rules: [{
                            required: true, message: '请输入接口编码', trigger: 'blur'
                        },{
                            max: 15, message: '输入字符不超过15', trigger: 'blur'
                        },{
                            pattern: this.regex.ennum_,
                            message: '只能输入英文、数字、下划线',
                            trigger: 'blur'
                        },{
                            validator: ruleApiCode,
                            trigger: 'blur'
                        }]
                    }],
                    /*条件数据库开始*/
                    row2:[{
                        name: 'isFlag',
                        label: '是否单点',
                        span: 12,
                        rules: [{
                            required: true,
                            message: '请选择条件数据源',
                            trigger: 'blur'
                        },{
                            required: false,
                            message: '请选择条件数据源',
                            trigger: 'blur'
                        }]
                    }],
                    /*条件数据库结束*/
                    row3:[{
                        name: 'searchId',
                        label: '数据源',
                        span: 12,
                        rules: [{
                            required: true,
                            message: '请选择数据源',
                            trigger: 'blur'
                        }]
                    },{
                        name: 'apiType',
                        label: '数据类型',
                        span: 12,
                        rules : [{
                            required: true,
                            message: '请选择数据类型',
                            trigger: 'blur'
                        }]
                    }],
                    row4:[{
                        name: 'shSql',
                        label: '查询语句',
                        span: 24,
                        rules: [{
                            required: true,
                            message: '请输入sql',
                            trigger: 'blur'
                        },{
                            min: 10,
                            max: 1000,
                            message: '输入的字符长度应在10-1000之间',
                            trigger: 'blur'
                        }]
                    }],
                    row5:[{
                        name: 'shParam',
                        label: '参数',
                        span: 24,
                        rules: [{
                            required: true,
                            message: '请输入参数',
                            trigger: 'blur'
                        },{
                            min: 2,
                            max: 50,
                            message: '输入的字符长度应在2-50之间',
                            trigger: 'blur'
                        }]
                    }],
                    row6:[{
                        name: 'remark',
                        label: '备注',
                        span: 24,
                        rules: [{
                            max:512,
                            message:'最多输入512个字',
                            trigger: 'blur'
                        }
                        ]
                    }]
                },
                datas: {
                    apiName: '',
                    apiCode: '',
                    serviceName: '',
                    apiUrl:'',
                    state:'',
                    criteriaSearchId:'',
                    isFlag:'1',
                    criteriaSql:'',
                    searchId:'',
                    apiType:'',
                    shSql:'',
                    shParam:'',
                    remark:'',
                    addTime: '',
                },
            }
        },
        methods: {

            handleClick() {
                this.searchId;
                this.shSql;
                this.shParam;
                this.dialogTableVisible = true;
            },
            //新增、修改、重置
            addOrEdit () {
                this.request.getId('/bigdata-visual/modelData/shApi/', this.openType).then((res) => {
                    const data = res.data;

                    for (let key in this.datas) {
                        if (!data[key]) {
                            this.datas[key] = ''
                        }
                        else {
                            this.datas[key] = data[key]
                        }
                    }
                    //新增给是否单点给默认值
                    if(this.openType=="-1"){
                        this.datas.isFlag = "1";
                    }
                })

            },
            search () {
                this.request.get('/bigdata-visual/modelData/source').then((res) => {
                    this.searchList = res.data;
                })
            },
            search2 () {
            this.request.get('/bigdata-visual/modelData/sysParam/findTwo').then((res) => {
            		this.searchList2 = res.data;
                    this.searchList2.map(function (item) {//处理数据太长的样式问题
                        if(item.z.length>25){
                            item.z = item.z.substr(0,35)+"..."
                        }
                        return item;
                    })
            	})
            },

            handleTest: function(name){

            },
            addRoutes1 () {
                const th=this
                th.$router.push({
                    name: 'bigdata-visual-modelData-gainData',
                    query: {data: th.datas}
                })

            }

        },

        computed: {
            urlSubmit () {
                return this.openType === -1 ? '/bigdata-visual/modelData/shApi/create' : '/bigdata-visual/modelData/shApi/update/' + this.openType
            },
            submitType () {
                return this.openType === -1 ? 'post' : 'put'
            }
        },
        created: function () {
            this.request.oprahfun(this)
            this.openType = this.$route.query.openType ? this.$route.query.openType : -1;
            this.pageload = false;
            this.addOrEdit();
            this.search();
            this.search2();
        }
    }
</script>
